type DividerProps = {
  widthPercent?: number
}

const Divider = ({ widthPercent = 100 }: DividerProps): JSX.Element => {
  return <div className={`bg-grey-light w-[${widthPercent}%] h-px`}></div>
}

export default Divider
